// import React from 'react';
// import ReactDOM from 'react-dom/client'; // Ensure this is imported
// // import MyApp from './app1';
// import Contactform from './ContactForm';
// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <React.StrictMode>
//     <Contactform/>
//   </React.StrictMode>
// );

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

import './index.css';
// import SignInForm from './SignInForm';
// import Dashboard from './Dashboard';
// import SignUpForm from './SignUpForm';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
   <React.StrictMode>
    <div>
      {/* <SignInForm/> */}
      <App/>
     
      {/* <SignUpForm/> */}
    </div>
   </React.StrictMode>
);
